import styled from "styled-components";

export const PricingWrapper = styled.div`
  margin: 5rem 0;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -50px;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 4px;
    background: linear-gradient(45deg, #ffffff 0%, #cccccc 100%);
    border-radius: 2px;
  }
`;

export const PricingCard = styled.div`
  background: linear-gradient(135deg, #000000 0%, #333333 100%);
  border-radius: 20px;
  padding: 2.5rem 2rem;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1), 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
  text-align: center;
  margin-bottom: 2rem;

  &.popular {
    background: linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%);
    border: 2px solid #000000;
    color: #000000;

    .popular-badge {
      position: absolute;
      top: -10px;
      left: 50%;
      transform: translateX(-50%);
      background: #000000;
      color: #ffffff;
      padding: 5px 15px;
      border-radius: 15px;
      font-size: 0.8rem;
      font-weight: 600;
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
    transition: left 0.5s;
  }

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2), 0 10px 25px rgba(0, 0, 0, 0.1);
    border-color: rgba(255, 255, 255, 0.3);

    &::before {
      left: 100%;
    }
  }

  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

export const PricingTitle = styled.h3`
  font-size: 1.8rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 1rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  .popular & {
    color: #000000;
  }
`;

export const PricingPrice = styled.div`
  font-size: 3rem;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 2rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  .popular & {
    color: #000000;
  }
`;

export const PricingFeatures = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 2rem;
  color: #cccccc;
  text-align: left;
  max-width: 250px;
  margin-left: auto;
  margin-right: auto;

  li {
    margin-bottom: 0.8rem;
    font-size: 1rem;
    line-height: 1.4;
  }

  .popular & {
    color: #333333;
  }
`;

export const PricingButton = styled.button`
  margin-top: 1rem;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
  }
`;
